module.exports = __webpack_public_path__ + "static/img/icon9.90c129e6.gif";